export default __webpack_public_path__ + "static/media/private-group.bc4d777a.svg";